import React, { useEffect, useState } from 'react';
import { Alert, Button, Card, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import segnalaMancanti from '../../../components/Util/campiMancanti';
import { IMPOSTAZIONI_SIMULAZIONE, SOLLECITI_PREDEFINITI, leggiSolleciti, salvaSolleciti } from '../../../../api-client/impostazioniSistema';

/*
 * Impostazioni › Certificati medici: dopo quanti giorni dalla richiesta della struttura il sistema manda da
 * solo il primo, il secondo e il terzo sollecito al player (email + notifica nell'app), se non ha ancora
 * risposto. I solleciti inviati si vedono nella scheda del certificato (tab Solleciti).
 */

const CAMPI = [
    { chiave: 'firstReminderDays', etichetta: 'Primo sollecito dopo' },
    { chiave: 'secondReminderDays', etichetta: 'Secondo sollecito dopo' },
    { chiave: 'thirdReminderDays', etichetta: 'Terzo sollecito dopo' },
];

export const SollecitiCertificati = () => {
    const [valori, setValori] = useState(null);
    const [errore, setErrore] = useState('');
    const [salvato, setSalvato] = useState(false);
    const [inCorso, setInCorso] = useState(false);

    useEffect(() => {
        leggiSolleciti().then((r) => {
            if (!r || r.error) { setErrore(r?.error || 'Impossibile leggere le impostazioni.'); setValori({ ...SOLLECITI_PREDEFINITI }); return; }
            setValori(r);
        });
    }, []);
    useEffect(() => {
        if (!salvato) return undefined;
        const t = setTimeout(() => setSalvato(false), 2500);
        return () => clearTimeout(t);
    }, [salvato]);

    // Giorni mancanti o sbagliati: si evidenziano i campi, senza finestra (set-ui «Dati mancanti»)
    const controlla = () => {
        const numeri = CAMPI.map((x) => Number(valori[x.chiave]));
        const mancanti = [];
        CAMPI.forEach((x, i) => {
            const vuoto = String(valori[x.chiave] ?? '').trim() === '';
            if (vuoto) mancanti.push({ campo: x.chiave, messaggio: 'Manca il numero di giorni' });
            else if (!Number.isInteger(numeri[i]) || numeri[i] < 1 || numeri[i] > 365) mancanti.push({ campo: x.chiave, messaggio: 'I giorni devono essere un numero intero da 1 a 365' });
        });
        if (mancanti.length === 0) {
            const [a, b, c] = numeri;
            if (!(a < b)) mancanti.push({ campo: CAMPI[1].chiave, messaggio: 'Il secondo sollecito deve arrivare dopo il primo' });
            if (!(b < c)) mancanti.push({ campo: CAMPI[2].chiave, messaggio: 'Il terzo sollecito deve arrivare dopo il secondo' });
        }
        return segnalaMancanti(mancanti);
    };

    const salva = async (e) => {
        e.preventDefault();
        if (controlla() > 0) return;
        setInCorso(true);
        const r = await salvaSolleciti(valori);
        setInCorso(false);
        if (r?.error) { setErrore(r.error); return; }
        setSalvato(true);
    };

    if (!valori) return <div className="text-center py-5"><Spinner animation="border" role="status" /></div>;

    return (
        <>
            <Modal show={!!errore} onHide={() => setErrore('')} centered>
                <Modal.Header closeButton><Modal.Title>Controlla i dati</Modal.Title></Modal.Header>
                <Modal.Body>{errore}</Modal.Body>
            </Modal>
            {IMPOSTAZIONI_SIMULAZIONE && (
                <Alert variant="warning" className="text-dark">
                    <strong>Simulazione:</strong> i valori restano in questo browser finché il backend non ha la rotta. La
                    simulazione dei certificati li usa già per calcolare i solleciti automatici.
                </Alert>
            )}
            <Form onSubmit={salva} noValidate>
                <Card>
                    <Card.Body className="sid-card-body--spaced">
                        <h5 className="sid-form-section">Solleciti automatici del certificato medico</h5>
                        <p className="sid-nota-leggibile">
                            Se il player non risponde alla richiesta di una struttura, il sistema gli rimanda da solo l'email e la
                            notifica nell'app. I giorni si contano dalla richiesta. Dopo il terzo sollecito non parte più nulla:
                            la struttura può sempre sollecitare a mano dalla scheda.
                        </p>
                        <Row className="g-4">
                            {CAMPI.map((x) => (
                                <Col md={4} key={x.chiave}>
                                    <Form.Label htmlFor={x.chiave}>{x.etichetta} *</Form.Label>
                                    <div className="d-flex align-items-center gap-2">
                                        <Form.Control
                                            id={x.chiave}
                                            type="number"
                                            min={1}
                                            max={365}
                                            style={{ maxWidth: 110 }}
                                            value={valori[x.chiave]}
                                            onChange={(e) => setValori({ ...valori, [x.chiave]: e.target.value })}
                                        />
                                        <span>giorni</span>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Card.Body>
                </Card>
                <div className="d-flex justify-content-end mt-4">
                    <Button type="submit" className="btn btn-primary" disabled={inCorso}>Salva</Button>
                </div>
            </Form>
            {salvato && <div className="sid-avviso-salvato" role="status">✓ Modifica salvata</div>}
        </>
    );
};

export default SollecitiCertificati;
